import { createFileRoute } from "@tanstack/react-router";

import { AdminPricingMarkup } from "@/features/admin/components/AdminPricingMarkup";

/**
 * Markup route — platform-admin sets the margin % applied on top of the raw
 * LLM cost. Mounted under the Admin shell, which gates on ``isPlatformAdmin``
 * in ``beforeLoad`` (so this leaf is platform-admin-only for free); every BE
 * mutation additionally enforces ``require_platform_admin``.
 */
export const Route = createFileRoute("/_authed/_modal/admin/pricing-markup")({
  component: AdminPricingMarkup,
});
